import React, { useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { Offcanvas } from 'bootstrap';

const Navbar = () => {
  const location = useLocation();
  const isTestimonialActive = location.hash === '#testimo';

  const offcanvasRef = useRef(null);

  // Initialize Bootstrap Offcanvas safely in React
  useEffect(() => {
    if (offcanvasRef.current) {
      Offcanvas.getOrCreateInstance(offcanvasRef.current);
    }
  }, []);

  const toggleOffcanvas = () => {
    const el = document.getElementById('offcanvasNavbar');
    const instance = Offcanvas.getOrCreateInstance(el);
    instance.toggle();
  };

  const closeOffcanvas = () => {
    const el = document.getElementById('offcanvasNavbar');
    const instance = Offcanvas.getInstance(el);
    instance?.hide();
  };

  return (
    <nav className="navbar navbar-light bg-light fixed-top">
      <div className="container-fluid position-relative">

        {/* Logo */}
        <Link className="navbar-brand" to="/">
          <img
            src={process.env.PUBLIC_URL + '/Images/myLogo.svg'}
            alt="Logo"
            style={{ height: '40px' }}
          />
        </Link>

        {/* Mobile Toggle Button */}
        <button
          className="navbar-toggler d-lg-none ms-auto"
          type="button"
          aria-label="Toggle navigation"
          onClick={toggleOffcanvas}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Desktop Menu */}
        <div className="d-none d-lg-flex position-absolute start-50 translate-middle-x">
          <ul className="navbar-nav flex-row">
            <li className="nav-item mx-2">
              <Link
                className={`nav-link hover-effect ${location.pathname === '/aboutus' ? 'active' : ''}`}
                to="/aboutus"
              >
                About Us
              </Link>
            </li>

            <li className="nav-item mx-2">
              <Link
                className={`nav-link hover-effect ${location.pathname === '/Service' ? 'active' : ''}`}
                to="/Service"
              >
                Services
              </Link>
            </li>

            <li className="nav-item mx-2">
              <HashLink
                smooth
                className={`nav-link hover-effect ${isTestimonialActive ? 'active' : ''}`}
                to="/#testimo"
              >
                Testimonial
              </HashLink>
            </li>

            <li className="nav-item mx-2">
              <Link
                className={`nav-link hover-effect ${location.pathname === '/blog' ? 'active' : ''}`}
                to="/Blog"
              >
                Blog
              </Link>
            </li>

            <li className="nav-item mx-2">
              <Link
                className={`nav-link hover-effect ${location.pathname === '/casestudy' ? 'active' : ''}`}
                to="/CaseStudy"
              >
                Case Studies
              </Link>
            </li>

            <li className="nav-item mx-2">
              <Link
                className={`nav-link hover-effect ${location.pathname === '/portfolio' ? 'active' : ''}`}
                to="/portfolio"
              >
                Portfolio
              </Link>
            </li>
          </ul>
        </div>

        {/* Desktop Contact Button */}
        <div className="d-none d-lg-flex ms-auto">
          <Link className="btn btn-primary1" to="/Hire">
            Contact Us
          </Link>
        </div>

        {/* Mobile Offcanvas */}
        <div
          ref={offcanvasRef}
          className="offcanvas offcanvas-end d-lg-none"
          tabIndex="-1"
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
              <img
                src={process.env.PUBLIC_URL + '/Images/myLogo.svg'}
                alt="Logo"
                style={{ height: '40px' }}
              />
            </h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={closeOffcanvas}
            ></button>
          </div>

          <div className="offcanvas-body">
            <ul className="navbar-nav flex-grow-1 pe-3">
              <li className="nav-item">
                <Link
                  className="nav-link hover-effect"
                  to="/aboutus"
                  onClick={closeOffcanvas}
                >
                  About Us
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  className="nav-link hover-effect"
                  to="/Service"
                  onClick={closeOffcanvas}
                >
                  Services
                </Link>
              </li>

              <li className="nav-item">
                <HashLink
                  smooth
                  className="nav-link hover-effect"
                  to="/#testimo"
                  onClick={closeOffcanvas}
                >
                  Testimonial
                </HashLink>
              </li>

              <li className="nav-item">
                <Link
                  className="nav-link hover-effect"
                  to="/Blog"
                  onClick={closeOffcanvas}
                >
                  Blog
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  className="nav-link hover-effect"
                  to="/casestudy"
                  onClick={closeOffcanvas}
                >
                  Case Studies
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  className="nav-link hover-effect"
                  to="/portfolio"
                  onClick={closeOffcanvas}
                >
                  Portfolio
                </Link>
              </li>
            </ul>

            <div className="mt-3">
              <Link
                className="btn btn-primary1 w-100"
                to="/Hire"
                onClick={closeOffcanvas}
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>

      </div>
    </nav>
  );
};

export default Navbar;
